document.addEventListener('DOMContentLoaded', () => {

    //открытие всех тегов при клике на кнопку "..."
    const tags_more = document.querySelector("[data-js='tags-more']")
    const tags_more_wrapper = document.querySelector('.tags__item-wrapper')
    const tags_overlay = document.querySelector('.tags__item-overlay')
    const html_no_scroll = document.getElementsByTagName('html')[0];
    const screen_width = window.screen.width

    if (tags_more && tags_more_wrapper) {

        document.addEventListener("click", e => {
            if (!e.target.closest('.tags__item-label') && !e.target.closest('.tags__item-wrapper-inner-bg')) {
                tags_more_wrapper.classList.remove("active")
                tags_overlay.classList.remove("active")

                if (screen_width <= 1279.5) {
                    html_no_scroll.classList.remove("html_no-scroll")
                }
            }
        })

        tags_more.addEventListener("click", function(e) {
            e.preventDefault()
            tags_more_wrapper.classList.toggle("active")
            tags_overlay.classList.toggle("active")

            if (screen_width <= 1279.5) {
                html_no_scroll.classList.toggle("html_no-scroll")
            }
        })
    }

    //ajax submit filter tags
    const checkboxs_filter = document.querySelectorAll("input[data-js='filter']")
    const submit_button = document.querySelector("[data-js='submit-filter']")


    if(checkboxs_filter && submit_button) {

        if (screen_width <= 1279.5) {
            submit_button.addEventListener('click', () => doFilterTags())
        } else {
            let timer = 1

            checkboxs_filter.forEach(function (checkbox) {
                checkbox.addEventListener('change', () => {

                    if (timer)
                        clearTimeout(timer);

                    timer = setTimeout(() => doFilterTags(), 1300);
                })
            })
        }
    }
    function doFilterTags() {

        if(checkboxs_filter && submit_button) {
            checkboxs_filter.forEach(function (checkbox) {
                tags = Array
                    .from(checkboxs_filter)
                    .filter((checkbox) => checkbox.checked)
                    .map((checkbox) => checkbox.dataset.tag);
            })

            tags_more_wrapper.classList.remove("active")
            tags_overlay.classList.remove("active")
            html_no_scroll.classList.remove("html_no-scroll")

            param = "?tags=" + tags.join(",")
            url = submit_button.dataset.url + param
            history.pushState({}, "", param)

            window.location.reload();

            // fetch(url).then(response => {
            //     return response.text()
            // }).then(text => {
            //     document.querySelector(".articles-wrapper").innerHTML = text
            //     document.querySelector('#articles').scrollIntoView({behavior: "smooth", inline: "start"});
            // }).catch(error => {
            //     console.log('error:', error)
            //
            //     document.querySelector(".articles-wrapper").innerHTML = error
            //     document.querySelector('#articles').scrollIntoView({behavior: "smooth", inline: "start"});
            // })
        }
    }

    //ajax load more articles
    const load_more_button = document.querySelector("[data-js='load-more']")
    if(load_more_button) {
        let current_pages = 1

        load_more_button.addEventListener("click", e => {
            load_more_button.classList.add("active")
            load_more_button.innerHTML = load_more_button.dataset.load


            pagen = getParam("PAGEN_1") ? "?PAGEN_1=" + (parseInt(getParam("PAGEN_1")) + 1) : "?PAGEN_1=2"
            tags = getParam("tags") ? "&tags=" + getParam("tags") : ""
            param = pagen + tags
            url = load_more_button.dataset.url + param
            max_pages = load_more_button.dataset.pages


            // console.log("PAGEN_1: ", pagen)
            // console.log("TAGS: ", tags)

            fetch(url).then(response => {
                return response.text()
            }).then(text => {

                history.pushState("", "", param)

                const parser = new DOMParser();
                const parsedHTML = parser.parseFromString(text, "text/html").querySelectorAll(".articles-item");

                if(parsedHTML) {
                    parsedHTML.forEach((key, val) => {
                        document.querySelector(".articles-wrapper").append(key)
                    })
                } else {
                    load_more_button.remove()
                }

                current_pages++
                if(current_pages == max_pages) {
                    load_more_button.remove()
                }

                load_more_button.classList.remove("active")
                load_more_button.innerHTML = load_more_button.dataset.state
            }).catch(error => {
                console.log('error:', error)

                document.querySelector(".articles-wrapper").append(error)
                load_more_button.classList.remove("active")
            })
        })
    }

    function getParam(name){
        if(name=(new RegExp('[?&]'+encodeURIComponent(name)+'=([^&]*)')).exec(location.search))
            return decodeURIComponent(name[1]);
    }


    //reveal description in list
    const handler = document.querySelector("[data-js='show']")
    const copllapse_text = document.querySelector('#wysiwyg')

    if(handler) {
        handler.addEventListener("click", e => {
            e.target.classList.toggle("active")
            copllapse_text.classList.toggle("active")
        })
    }



    /* article detail start */

    //show content right
    const bshow = document.querySelector("[data-js='show-content']")
    const tcontent = document.querySelector("[data-js='target-content']")
    if(bshow && tcontent) {
        bshow.addEventListener("click", () => {
            tcontent.classList.toggle("active")
            bshow.classList.toggle("active")
        });
    }

    //like action
    const button_like = document.querySelector("[data-js='like']")
    if(button_like) {

        url = button_like.dataset.url
        id = button_like.dataset.id
        count = parseInt(button_like.dataset.count)
        is_like = getCookie("like_id_" + id)

        if(is_like) {
            button_like.classList.add("active")
        }

        button_like.addEventListener("click", () => {

            url = button_like.dataset.url
            id = button_like.dataset.id
            count = parseInt(button_like.dataset.count)
            is_like = getCookie("like_id_" + id)

            if(is_like) {
                alert("Вы уже поставили лайк!")
                return false
            }

            data_form = {
                id: id,
                count: count
            }

            fetch(url, {

                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data_form)

            }).then(response => { return response.json() }).then(data => {

                count++
                button_like.innerHTML = count
                button_like.setAttribute("data-count", count)
                setCookie("like_id_" + id, 1)
                console.log("count", count)

            }).catch(error => {
                console.log("error", error)

            })
        });
    }

    function getCookie(name) {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    function setCookie(name, value, options = {}) {
        if(name && value) {
            options = {
                path: '/',
                expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
            };

            if (options.expires.toUTCString) {
                options.expires = options.expires.toUTCString();
            }
            let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

            for (let optionKey in options) {
                updatedCookie += "; " + optionKey;
                let optionValue = options[optionKey];
                if (optionValue !== true) {
                    updatedCookie += "=" + optionValue;
                }
            }
            document.cookie = updatedCookie;
        }
    }

});


function wrapTable(el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapperTable = document.createElement('div');
    wrapperTable.classList = "wrapper-in";
    wrapperTable.appendChild(el);
    wrapper.classList = 'wrapper-table';
    wrapper.appendChild(wrapperTable);
}
if ((window.screen.width <= 1279.5) && (document.querySelector('table'))) {
    wrapTable(document.querySelector('table'), document.createElement('div'));
}

